import { Box, Checkbox, useSlotRecipe } from '@chakra-ui/react';

import merge from 'lodash/merge';

import { IconsLinear } from '@nocowanie/icons';

import { SearchEngineInstantReservationCheckboxProps } from './search-engine-instant-reservation-checkbox.props';

import { defaultSearchEngineTranslation } from '../../../../lib/models';

export const SearchEngineInstantReservationCheckbox = ({
    setValue,
    onInputValueUpdated,
    translationData = defaultSearchEngineTranslation,
    watch,
    withBackground = false,
    css,
}: SearchEngineInstantReservationCheckboxProps) => {
    const recipe = useSlotRecipe({ key: 'searchEngineInstantReservationCheckbox' });
    const styles = recipe({
        variant: withBackground ? 'withBg' : undefined,
    });

    return (
        <Checkbox.Root
            checked={watch('instantReservation')}
            onCheckedChange={details => {
                setValue('instantReservation', !!details.checked);
                onInputValueUpdated();
            }}
            data-testid="search-engine-instant-reservation-checkbox"
            alignItems={'flex-start'}
            size={'lg'}
            css={merge(styles.root, css)}
        >
            <Checkbox.HiddenInput />
            <Checkbox.Control />
            <Checkbox.Label
                fontSize={{
                    base: 'xs',
                    md: 'md',
                }}
                lineHeight={1.5}
            >
                <Box fontWeight={'700'}>
                    {translationData.instantReservationLabel}
                    <IconsLinear.Flash
                        color={'selectiveYellow'}
                        fill={'selectiveYellow'}
                        ml={{
                            base: 1,
                            md: 2,
                        }}
                    />
                </Box>
                <Box color={'green.800'}>{translationData.instantReservationDescription}</Box>
            </Checkbox.Label>
        </Checkbox.Root>
    );
};
